<div class="flex w-80 flex-col divide-x-0 divide-y divide-solid divide-white divide-opacity-25 text-white">
  @for (absence of absences; track $index) {
    <absence-tooltip-item [absence]="absence" [date]="date" [showName]="showName" />
  }
</div>
